import { Box, Button, Skeleton, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContractCardContainer = styled(Stack, {
    shouldForwardProp: (prop) => prop !== "isPreviewHidden" && prop !== "isPreview",
})<{ isPreviewHidden: boolean; isPreview: boolean }>(({ theme, isPreviewHidden, isPreview }) =>
    theme.unstable_sx({
        display: isPreviewHidden ? "none" : "flex",
        flexGrow: 1,
        height: "100%",
        p: isPreview ? 0 : 4,
        boxShadow: isPreview ? "none" : "close",
        borderRadius: 1,
    }),
);

export const ContractHeaderTitle = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        mb: 0,
        pr: 4,
    }),
);

export const ContractNumberText = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mb: 4,
    }),
);

export const MobileDetailLinkBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        mt: "auto",
    }),
);

export const ContractCardSkeletonRect = styled(Skeleton)<{ width: number }>(({ theme, width }) =>
    theme.unstable_sx({
        width: `calc(${String(width * 100)}% - ${theme.spacing(6)}/2)`,
        mb: 6,
    }),
);

export const SkeletonHeaderTitle = styled(Skeleton)({
    width: "70%",
    height: "40px",
});

export const SkeletonHeaderContractNumber = styled(Skeleton)({
    width: "20%",
    height: "20px",
});

export const SkeletonHeaderSavings = styled(Skeleton)({
    width: "30%",
});

export const CarretContainer = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        py: 4,
        px: 3,
        cursor: "pointer",
    }),
);

export const CarretButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        p: 0,
    }),
);
